import { useQuery } from "@tanstack/react-query"
import { fetchDocumentCompliance } from "../services/suppliersProfile.service"

export const useDocumentComplianceData = ({ supplierId, userLogged }) => {
	const query = useQuery({
		queryKey: ["documentCompliance", supplierId],
		queryFn: () =>
			fetchDocumentCompliance(supplierId, {
				userRol: userLogged?.rol,
				userDataID: userLogged?.dataID,
			}),
		enabled: !!supplierId && !!userLogged,
		refetchOnMount: true,
	})

	return {
		complianceData: query.data,
		isLoading: query.isLoading,
		refetch: query.refetch,
	}
}
